import { useMemo } from 'react';

const evalRegex = ({ message, regex }: { message: string; regex: RegExp }) => (
  // NOTE:
  // This checks for value because it's one of the few validators that
  // we use without requiring the user to enter a value.
  (value: string) => (value && !regex.test(value)
    ? message
    : undefined
  )
);

export const testTimeInputSupport = (): boolean => {
  let testInput;
  if (typeof document !== 'undefined') {
    testInput = document.createElement('input');
    testInput.setAttribute('type', 'time');
  }
  // test whether a new time input falls back to a text input or not
  return testInput && testInput.type !== 'text';
};

const format = (value = '') => value.toUpperCase();

// https://www.regextester.com/104041
const twelveHoursFormatRegex = /((1[0-2]|0[1-9]):([0-5][0-9]) ([ap][m]))/i;

type UseTimeInput = {
  format: (value: string) => string;
  validate: ((value: string) => string | undefined) | undefined;
  timeInputIsSupported: boolean;
};

const useTimeInput = (): UseTimeInput => {
  const timeInputIsSupported = useMemo(() => testTimeInputSupport(), []);

  const validate = useMemo(() => (timeInputIsSupported
  // If it's supported we're going to trust the browser
  // to give us good input
    ? undefined
    : evalRegex({
      message: 'Invalid time format.',
      regex: twelveHoursFormatRegex,
    })), [timeInputIsSupported]);

  return {
    format,
    validate,
    timeInputIsSupported,
  };
};

export default useTimeInput;
